import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterializeModule} from './materialize/materialize.module';
import {HeaderComponent} from './header/header.component';
import {HomeComponent} from './home/home.component';
import {HomeHeaderComponent} from './home/home-header/home-header.component';
import {HomeContentComponent} from './home/home-content/home-content.component';
import {HttpClientModule} from '@angular/common/http';
import {SegmentModule} from './segment/segment.module';
import {SegmentComponent} from './segment/segment.component';
import {SegmentHeaderComponent} from './segment/segment-header/segment-header.component';
import {SegmentContentComponent} from './segment/segment-content/segment-content.component';
import {SegmentProductsComponent} from './segment/segment-products/segment-products.component';
import {SegmentDetailsComponent} from './segment/segment-details/segment-details.component';
import {FlexLayoutModule} from '@angular/flex-layout';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    SegmentComponent,
    HomeHeaderComponent,
    HomeContentComponent,
    SegmentHeaderComponent,
    SegmentContentComponent,
    SegmentProductsComponent,
    SegmentDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterializeModule,
    HttpClientModule,
    SegmentModule,
    FlexLayoutModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
